<div class="mf-btn mf-btn-txt-{{txtAlign}} {{(color == 'mf-primary') ? 'mf-btn-color-mf-primary' : 'comparatoreMF-box-shadow'}}" [ngStyle]="{'padding': padding}" [ngClass]="{'mf-btn-disabled': disabled}">
    <ng-content></ng-content>
</div>